<div fxLayout="row" fxLayoutGap="0rem" fxLayoutAlign="center center">
  <div fxFlex="20%" fxFlex.lt-xl="40%" fxFlex.lt-md="60%" fxFlex.lt-sm="80%">
    <header style="padding: 2rem">
      <ng-content select="[header]"></ng-content>
    </header>
    <main>
      <ng-content select="[content]"></ng-content>
    </main>
    <footer>
      <ng-content select="[footer]"></ng-content>
    </footer>
  </div>
</div>
